import { env } from "@infra/implementations/config/env";

export const CREATE_NEW_GROWER = "Create new grower...";
export const CREATE_NEW_SALESPERSON = "Create new salesperson...";
export const FOLDER_TOKEN_PREFIX = "Folder Level ";
export const IS_PROD = env.environmentName === "production";
export const IS_DEV = env.environmentName === "development";
export const IS_DEV_SENTRY = env.environmentName === "development-sentry";
export const DEBUG = IS_DEV || IS_DEV_SENTRY || env.debug;
export const INVALID_USERCONTEXT = "Authentication error. Try logging out and back in.";
export const DEFAULT_PAGE: string = "/home";
